import type { CropperOptions } from 'ngx-image-cropper';

import { AcceptEnum } from '@commons/bo-ui/form/file-picker/models/accept.enum';

export interface FilePickerOptions {
  acceptedFormats: AcceptEnum[];
  maxSizePerFileInMB: number;
  caption?: string;
  title?: string;
  hideTitle: boolean;
  hideCaption: boolean;
  enableCropper: boolean;
  cropperOptions?: FilePickerCropperOptions;
  publicUpload: boolean;
  additionalAllowedRoles: string[];
  additionalAllowedUsers: string[];
  additionalAllowedApps: string[];
  multiUpload: boolean;
  requiredSize?: {
    width: number;
    height: number;
  };
  minimumSize?: `${number}x${number}`;
  applySvgCurrentColor?: boolean;
}

export type FilePickerCropperOptions = Partial<CropperOptions>;

export const FILE_PICKER_DEFAULT_OPTIONS: FilePickerOptions = {
  acceptedFormats: [AcceptEnum.JPG, AcceptEnum.PNG, AcceptEnum.SVG, AcceptEnum.PDF],
  maxSizePerFileInMB: 5,
  hideTitle: false,
  hideCaption: false,
  enableCropper: false,
  publicUpload: true,
  additionalAllowedApps: [],
  additionalAllowedRoles: [],
  additionalAllowedUsers: [],
  multiUpload: false,
};
